<div class="all-page-combo-layout">
  <div class="all-page-feed">
    <div class="hpanel">
      <div class="panel-body border-radius-top-left-right-6">
        <div class="comNavBar bgCol">
          <div class="nav-iteam-1 m-t-8">
            <label for="">Invite Sent : {{ inviteLength }}</label>
          </div>
          <div class="nav-iteam-2">
            <div class="input-group f-l">
              <input #membersDataText type="text" class="form-control" placeholder="Search Invites "
                aria-label="Amount (to the nearest dollar)" name="searchadmin" id="searchadmin"
                [(ngModel)]="searchKey" (input)="onSearchInvite(membersDataText.value)" style="z-index: 1;"/>
              <span class="dummyBtn"></span>
            </div>
          </div>
          <div class="nav-iteam-3">
            <div class="btn-group" dropdown container="body">
              <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle hgop"
                aria-controls="dropdown-basic" style="border-radius: 8px !important; height: 32px !important;">
                All
                <ng-icon name="tablerFilter"></ng-icon>
              </button>
              <!-- <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
              </ul> -->
            </div>
          </div>
          <div class="nav-iteam-4">
          </div>
        </div>
      </div>
    </div>
    <div class="margin-top-5">
      <ng-container *ngIf="loadAPIcall && !loadScroll" >
        <div  class="col-md-6 col-lg-4 col-sm-12 padding-left-0 padding-right-5" style="padding-bottom: 5px;"
      *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
      <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
    </div>
      </ng-container>
      <div class="invite-body" *ngIf="(membersList | async)?.length > 0" infiniteScroll [alwaysCallback]="true"
        [infiniteScrollDistance]="5" [infiniteScrollThrottle]="300" (scrolled)="onScrollDown()">

      <div class="col-md-6 col-lg-4 col-sm-12 padding-left-0 padding-right-5" style="padding-bottom: 5px;"
        *ngFor="let data of (membersList | async)">
        <app-user-card [userDataInput]="data" [labelName]="'NETWORK'" [config]="userCardConfig"
          [button]="'PRIMARY'" [standard]="true"></app-user-card>
      </div>
      <ng-container *ngIf="loadScroll">
        <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0 pd-5"
          *ngFor="let n of [1, 2, 3]">
          <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
        </div>
      </ng-container>

      <div class="col-sm-12 pl-1 end" *ngIf="stopScroll && (membersList | async)?.length > 0"
        style="text-align: center;padding-top: 1rem;">
        <div class="col-sm-12">
          <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
          <ng-icon name="tablerCircleCheck"></ng-icon>

        </div>
        <div class="col-sm-12">
          <p class="fontchange">You've reached the bottom of the page</p>
        </div>
      </div>
    </div>

      <div class="col-md-12 pad" *ngIf="(membersList | async)?.length === 0  && !loadAPIcall">
        <app-nodata-found [title]="noDatafound"></app-nodata-found>
      </div>
    </div>
  </div>
  <div class="all-page-widget">
    <app-common-widget [page]="'TEAMS_MEMBER_PAGE'" [inputData]="'NETWORK'"></app-common-widget>
  </div>
</div>
